import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.sass']
})
export class TransactionsComponent implements OnInit {
  public banlist: any;
  public selectBan;
  public terminos;
  public subscribers;
  public screen = 2;
  public textoMovil = false;
  public accountList = sessionStorage.AccountList;
  public tabActive = 'Mis Equipos y Servicios';
  public offer;
  public expand = [];
  public sw1 = true;
  public sw2 = false;
  public viewNetflixTerminos = false;
  public viewNetflixPeperless = false;
  public isChecked = false;
  public paperlessCheck = false;
  public accountSel = "";
  public subscriberSel = "";
  public inicio = true;
  public subscriberCounter = 0;
  public paperless;
  public accountList2;
  public checkNetflix;
  firstNameField = sessionStorage.firstNameField;
  accountSubtypeField = sessionStorage.accountSubtypeField;
  returnPage = sessionStorage.returnPage;
  refillHistoryList = [];
  public status = "Estatus";
  public transactions = "Transacciones";
  newDate = new Date();
  actualYear = this.newDate.getFullYear();
  actualMonth = this.newDate.getMonth();
  public yearArray = [];
  public month = String(this.actualMonth);
  public year = String(this.actualYear);
  public type = "Transacciones";
  public selTab: number;
  public offers: Array<any>;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public cuentas;
  public totalAccountList;
  public subscribernumber;
  public accounInfo;
  public token;
  loadObserver: Subscription;

  constructor(public AngularFireAnalytics: AngularFireAnalytics, private router: Router, public appComponent: AppComponent, private loadingScreenService: LoadingScreenService, private services: Service, public global: GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("Transacciones");
    this.AngularFireAnalytics.logEvent("Transacciones-Screenview");
  }

  ngOnInit() {
    this.global.validateSession();
    if (this.global.sessionReview() == true) {
      this.token=sessionStorage.getItem("token");
      this.offers = [];
      this.banlist = JSON.parse(atob(sessionStorage.getItem("AccountList")));
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
      this.subscribers = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
      this.subscribernumber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo.subscriberNumberField;
      this.global.mask(this.subscribernumber);
      for (let i = 0; i < 1; i++) { // 2  es a partir de 2021
        this.yearArray[i] = this.actualYear - i;
      }
      this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
        this.dataLoading(value);
      });
    }
    this.getOffers(this.subscribers, 0);
  }
  refreshDataTo(event: Event) {
    if (this.global.validateSession() === true) {
      let index = parseInt(event.target["selectedIndex"]);
      let ban = this.currentList[index].account;
      sessionStorage.setItem("selectBan", btoa(ban));
      this.initializeData();
    }
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw) {
    if (this.postpago == true) {
      this.type = "postpaid";
    }
    else if (this.prepago == true) {
      this.type = "prepaid";
    }
    else if (this.telefoniaFijo == true) {
      this.type = "fixed";
    }
    this.subscribers = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;

    this.accounInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
    this.expand[0] = true;
    this.selTab = 1;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.offers = [];
    this.getOffers(this.subscribers, 0);
  }
  updateExpand(index) {
    if (this.global.validateSession() === true) {
      this.global.validateSession();
      this.expand[index] = !this.expand[index];
    }
  }
  ngOnDestroy() {
    this.loadObserver.unsubscribe();
  }
  getOffers(subscriber, index) {
    this.loadingScreenService.startLoading();
    this.offers = [];
    this.services.getPrepaidInfo(subscriber[index].subscriberNumberField, this.token).subscribe(data => {
      if (data.hasErrorField == false) {
        this.loadingScreenService.stopLoading();
        this.refillHistoryList = data.replenishListItemsField;
        if ((parseInt(subscriber.length) - 1) === index) {
          this.offers.push(JSON.parse(this.offersData(data, 3)));
          this.loadOffers(this.offers);
        }
        else {
          this.offers.push(JSON.parse(this.offersData(data, 3)));
          this.getOffers(subscriber, parseInt(index + 1));
        }
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.errorDescField);
      }
    });
  }
  offersData(data, row) {
    var offers = '';
    if (data.replenishListItemsField !== null) {

      offers = '{"HasError":false,"ErrorDesc":"","offersData":[';

      for (var i = 0; i < data.replenishListItemsField.length; i++) {
        if (i > 0) {
          offers += ',';
        }

        offers += '{"offers":[';
        offers += '{"amount":"' + data.replenishListItemsField[i].totalAmountField +
          '","date":"' + data.replenishListItemsField[i].createionDateField +
          '","nameProduct":"' + data.replenishListItemsField[i].sequenceNumberField +
          '","nameProductType":"' + data.replenishListItemsField[i].sequenceNumberField +
          '","transactionId":"' + data.replenishListItemsField[i].sequenceNumberField +
          '","status":"' + data.replenishListItemsField[i].sequenceNumberField + '"}';
        offers += ']}';
      }
      offers += ']}';
    }
    else {
      offers = '{"HasError":false,"ErrorDesc":"","offersData":[]}';
    }
    return offers;
  }
  loadOffers(offers) {
    var ofertas = '{"offers":[';
    for (var i = 0; i < offers.length; i++) {
      if (i > 0) {
        ofertas += ',';
      }

      ofertas += '{"offers":[' + JSON.stringify(offers[i]) + ']}';
    }
    ofertas += ']}';
    this.offers = JSON.parse(ofertas);
    if (this.subscribers.length > 0) {
      this.expand[0] = true;
    }
  }
  continueTransactions(subscriber) {
    if (this.month == "Seleccione un més") {
      var msj = "Debe seleccionar un més";
      this.global.notif("Aviso" + msj);
    } else {
      if (this.year == "Seleccione un año") {
        var msj = "Debe seleccionar un año";
        this.global.notif("Aviso" + msj);
      } else if (this.status == "Seleccione Estatus") {
        var msj = "Debe seleccionar Estatus";
        this.global.notif("Aviso" + msj);
      } else {
        this.services.getPrepaidInfo(subscriber, this.token).subscribe(data => {
          if (data.hasErrorField == false) {
            this.refillHistoryList = data.replenishListItemsField;
          }
          else { }
        });
      }
    }
  }
  refillOffersBySub(index) {
    this.loadingScreenService.startLoading();
    this.services.getPrepaidInfo(this.subscribers[index].subscriberNumberField, this.token).subscribe(data => {
      if (data.hasErrorField == false) {
        this.loadingScreenService.stopLoading();
        var offerstemp = JSON.parse(this.offersData(data, 3));
        this.offers['offers'][0].offers[0].offersData = offerstemp.offersData;
      }
    });
  }
  dataFormat(fecha) {

    var s = new Date(parseInt(fecha.date));
    var d = (s.getMonth() + 1) + '/' + s.getDate() + '/' + s.getFullYear();
    return d;
  }

}
